"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'dblogs.filter.dateFrom': '开始日期',
    'dblogs.filter.dateTo': '结束日期',
    'dblogs.filter.models': '模型',
    'dblogs.filter.models.placeholder': '所有模型',
    'dblogs.filter.operations': '操作',
    'dblogs.filter.operations.placeholder': '所有操作',
    'dblogs.filter.recordIds': '记录 ID',
    'dblogs.filter.recordIds.placeholder': '按 Enter 添加值',
    'dblogs.filter.search': '搜索',
};
